import { TextField } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { QuoteStatuses } from '../constants';
import { Dispatch, iRootState } from '../redux/store';
import useFormatMessage from '../useFormatMessage';

const FeedbackEntry = function FeedbackEntry(): React.ReactElement {
  const message = useSelector((state: iRootState) => state.feedback.message);
  const status = useSelector((state: iRootState) => state.quote.status);
  const dispatch = useDispatch<Dispatch>();
  const onChange = function handleOnChange(
    event: React.ChangeEvent<HTMLInputElement>
  ): void {
    dispatch.feedback.changeMessage(event.target.value);
  };

  function getMessageId() {
    switch (status) {
      case QuoteStatuses.ChangesRequested:
        return 'messagerequired';
      default:
        return 'messageoptional';
    }
  }

  function getDefaultMessageLabel() {
    switch (status) {
      case QuoteStatuses.ChangesRequested:
        return 'Message (required)';
      default:
        return 'Message (optional)';
    }
  }

  const messageLabel = useFormatMessage({
    id: getMessageId(),
    defaultMessage: getDefaultMessageLabel()
  });

  return (
    <TextField
      value={message}
      onChange={onChange}
      label={messageLabel}
      fullWidth
      variant='outlined'
      margin='dense'
      multiline
      rows={3}
      inputProps={{ maxLength: 2000 }}
    />
  );
};

export default FeedbackEntry;
